import batchHandleUrl from '../../../utils/url-handle'
const api = {
  // 获取规则配置
  getRuleByKey: {
    type: 'get',
    url: '/rule/execute/stringValue'    
  },
  // 批量获取规则配置
  getListByRuleKey: {
    type: 'post',
    url: '/rule/execute/listByRuleKey'
  }
}
export default batchHandleUrl(api)